import { Lookup, useLookup } from '@/providers'
import { MarketBasketWithSettings } from '@domain'
import { Stack } from '@mui/material'
import { useMarketBasketContext } from '@views/MarketBaskets/MarketBaskets.hooks'

import { BasketInfo } from './BasketInfo'
import { ButtonBar } from './ButtonBar'

export default function InfoBar({ showActions = false }: { showActions?: boolean }) {
	const { marketBasket, isLoading, isAnalysisComplete } = useMarketBasketContext()
	const marketSegments = useLookup(Lookup.MarketSegments)

	return (
		<InfoBarUi
			showActions={showActions}
			isLoading={isLoading}
			isAnalysisComplete={isAnalysisComplete}
			marketBasket={marketBasket}
			marketSegments={marketSegments}
		/>
	)
}

type UIProps = {
	showActions: boolean
	marketBasket: MarketBasketWithSettings
	isLoading: boolean
	isAnalysisComplete: boolean
	marketSegments: SimpleListItem[]
}

export function InfoBarUi({
	showActions,
	isLoading,
	isAnalysisComplete,
	marketBasket,
	marketSegments,
}: UIProps) {
	return (
		<Stack height="2.5rem" direction="row" alignItems="center" justifyContent="space-between">
			<BasketInfo
				isLoading={isLoading}
				marketBasket={marketBasket}
				marketSegments={marketSegments}
			/>

			{showActions && (
				<ButtonBar
					isLoading={isLoading}
					isAnalysisComplete={isAnalysisComplete}
					marketBasket={marketBasket}
				/>
			)}
		</Stack>
	)
}
